import { render, staticRenderFns } from "./Iconography.vue?vue&type=template&id=9f4dc90c"
import script from "./Iconography.vue?vue&type=script&lang=ts"
export * from "./Iconography.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports